export default "__VITE_ASSET__C3mLNOWd__"